export var CommunicationStatus = /*#__PURE__*/function (CommunicationStatus) {
  CommunicationStatus["Open"] = "Open";
  CommunicationStatus["Closed"] = "Closed";
  CommunicationStatus["Rejected"] = "Rejected";
  CommunicationStatus["PastDue"] = "PastDue";
  CommunicationStatus["Sent"] = "Sent";
  return CommunicationStatus;
}({});
